
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import DownloadAttachmentPreview from "@/app/ui/components/download-attachment-preview/index.vue";
import { ClientManagementController } from "@/app/ui/controllers/ClientManagementController";
import { ClientRegistrationController } from "@/app/ui/controllers/ClientRegistrationController";
import { ClientDetailUpdateItem } from '@/domain/entities/ClientManagement';
import { FlagsPermissionClient } from "@/feature-flags/flags-permission-client";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";

class Props {
  isManagement = prop<boolean>({
    required: false,
    default: false,
    type: Boolean
  });
}
@Options({
  components: {
    Title,
    DownloadAttachmentPreview
  }
})
class DetailBillingInformation extends Vue.with(Props) {
  get canPreviewAttachment(): boolean {
    return FlagsPermissionClient.permission_client_management_detail_pks_view.isEnabled();
  }
  get canPreviewAttachmentPKS(): boolean {
    return FlagsPermissionClient.permission_client_management_detail_pks_view.isEnabled();
  }
  formatDate = formatDate;
  get detailData() {
    if (this.isManagement) {
      return ClientManagementController.detailClientManagement;
    }

    return ClientRegistrationController.clientRegistrationDetail;
  }

  get newestUpdated() {
    if (this.detailData.detailUpdate.newestUpdatedContractInfo.length) {
      return this.detailData.detailUpdate.newestUpdatedContractInfo[0]
    }

    return new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: formatDate(this.detailData.clientCreatedAt)
    })
  }

  get newestUpdatedContractAttachment() {
    return this.detailData.detailUpdate.contractInfo?.is_reupload_contract ?? new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: this.detailData.clientCreatedAt as any
    })
  }

  get newestUpdatedPksAttachment() {
    return this.detailData.detailUpdate.contractInfo?.is_reupload_pks ?? new ClientDetailUpdateItem({
      updatedByName: this.detailData.clientCreatedBy,
      updatedAt: this.detailData.clientCreatedAt as any
    })
  }

  get hasPksAttachment() {
    return Boolean(this.detailData?.clientBilling?.pksAttachment);
  }

  get contractAttachmentUpdatedAt() {
    return this.newestUpdatedContractAttachment?.updatedAt
      ? formatDate(this.newestUpdatedContractAttachment.updatedAt)
      : "-";
  }

  get contractAttachmentUpdatedBy() {
    return this.newestUpdatedContractAttachment?.updatedByName || "-";
  }

  get pksAttachmentUpdatedAt() {
    return this.newestUpdatedPksAttachment?.updatedAt
      ? formatDate(this.newestUpdatedPksAttachment.updatedAt)
      : "-";
  }

  get pksAttachmentUpdatedBy() {
    return this.newestUpdatedPksAttachment?.updatedByName || "-";
  }
}
export default DetailBillingInformation;
